import asyncLib from 'async';
import { recurly_plans, recurly_base_url } from '../ConfigHolder';
import Azure from '../Azure';

class Subscription {
  constructor() {
    this.subscription_id = null;
  }

  fetchSubscriptionInfoForCurrentUser(cb, errorCb) {
    new Azure().fetchSubscriptionInfoForCurrentUser((result) => {
      this.subscription_id = result.data.subscription_id;
      cb(result.data);
    }, errorCb);
  }

  fetchEAPAccess(cb) {
    new Azure().fetchEAPAccess((result) => cb(result.data));
  }

  allowInviteCode(callback) {
    new Azure().allowInviteCode((result) => {
      callback(result.data);
    });
  }

  checkCouponCode(code, callback) {
    new Azure().checkCouponCode(code, (result) => {
      callback(result.data);
    });
  }

  startTrial(cb) {
    new Azure().createSubscription((result) => {
      const email = new Azure().getEmail();
      window.top.location.href = `${recurly_base_url}/subscribe/${recurly_plans.monthly}/${result.data}?email=${encodeURIComponent(email)}`;
    });
  }

  buyNewSubscription(term, quantity, billing_id, couponCode, finishedCb, threeDCallback) {
    const phases = [
      { key: 'update-account', message: 'Storing account details' },
      { key: 'verify-subscription', message: 'Verifying subscription' },
      { key: 'update-plan', message: 'Updating plan information' },
      { key: 'convert-trial-through-modify', message: 'Converting the trial' },
    ];

    const performRegularCheck = function (phase, complete) {
      new Azure().convertSubscription({
        term, billing_id, quantity, phase: phase.key, couponCode,
      }, (result) => {
        if (result.data.status === '3d-check') {
          perform3dCheck(result.data.token, phase, () => {
            complete();
          });
        } else if (result.data.status === 'phase-complete') {
          complete();
        } else if (['transaction_error', 'validation'].includes(result.data.status)) {
          complete(result.data);
        } else {
          alert('Received an unknown error - please contact support@55degrees.se');
        }
      });
    };

    const perform3dCheck = function (the_token, phase, complete) {
      console.log(`we need to do a 3d check for ${phase}`);

      threeDCallback(the_token, phase.key, phase.message, (new_3d_token) => {
        new Azure().convertSubscription({
          term, billing_id, quantity, phase: phase.key, retry_token: new_3d_token,
        }, (result) => {
          if (result.data.status === 'phase-complete') {
            complete();
          } else if (result.data.status === '3d-check') {
            perform3dCheck(result.data.token, phase, () => {
              complete();
            });
          } else {
            console.log(`Stuck at ${phase.key}`);
            console.log(JSON.stringify(result.data));
          }
        });
      });
    };

    asyncLib.forEachLimit(phases, 1, (phase, phase_done) => {
      performRegularCheck(phase, (callbackValue) => {
        // If there is callbackValue then it's transaction error
        if (!!callbackValue) {
          finishedCb(callbackValue);
        } else {
          phase_done();
        }
      });
    }, () => {
      finishedCb();
    });
  }

  gotoBilling() {
    new Azure().fetchAccountPage((result) => {
      window.top.location.href = result.data;
    });
  }

  fetchUpdateBillingInfoPage() {
    new Azure().fetchAccountPage((result) => {
      window.top.location.href = result.data;
    });
  }

  changeSubscription(term, quantity, billing_id, couponCode, finishedCb, threeDCallback) {
    const phases = [
      { key: 'update-account', message: 'Storing account details' },
      { key: 'verify-subscription', message: 'Verifying subscription' },
      { key: 'update-plan', message: 'Updating plan information' },
      { key: 'convert-trial-through-modify', message: 'Converting the trial' },
    ];

    const perform3dCheck = function (the_token, phase, complete) {
      threeDCallback(the_token, phase.key, phase.message, (new_3d_token) => {
        new Azure().convertSubscription({
          term, billing_id, quantity, phase: phase.key, retry_token: new_3d_token,
        }, (result) => {
          if (result.data.status === 'phase-complete') {
            complete();
          } else if (result.data.status === '3d-check') {
            perform3dCheck(result.data.token, phase, () => {
              complete();
            });
          } else {
            console.log(`Stuck at ${phase.key}`);
            console.log(JSON.stringify(result.data));
          }
        });
      });
    };

    const performRegularCheck = function (phase, complete) {
      new Azure().convertSubscription({
        term, billing_id, quantity, phase: phase.key, couponCode: couponCode,
      }, (result) => {
        if (result.data.status === '3d-check') {
          perform3dCheck(result.data.token, phase, () => {
            complete();
          });
        } else if (result.data.status === 'phase-complete') {
          complete();
        } else if (['transaction_error', 'validation'].includes(result.data.status)) {
          complete(result.data);
        } else {
          alert('Received an unknown error - please contact support@55degrees.se');
        }
      });
    };

    asyncLib.forEachLimit(phases, 1, (phase, phase_done) => {
      performRegularCheck(phase, (callbackValue) => {
        if (!!callbackValue) {
          finishedCb(callbackValue);
        } else {
          phase_done();
        }
      });
    }, () => {
      finishedCb();
    });
  }

  regenerateInviteCode(cb) {
    new Azure().regenerateInviteCode({ subscription: this.subscription_id }, (result) => {
      if (result.data && result.data.code) {
        cb(result.data.code);
      } else { cb(null); }
    });
  }

  redeemInviteCode(code, cb) {
    new Azure().redeemInviteCode({ code }, (result) => {
      cb(result.data.status);
    });
  }

  fetchAllManagedUsers(cb) {
    new Azure().fetchAllUsers({ subscription: this.subscription_id }, (result) => {
      cb(result.data.users, result.data.max_users, result.data.inviteCode);
    });
  }

  addCurrentBillingUserToManagedUsers(cb) {
    new Azure().addCurrentBillingUserToManagedUsers({ subscription: this.subscription_id }, (result) => {
      cb(result.data.users, result.data.max_users, result.data.inviteCode);
    });
  }

  removeManagedUser(user_id, cb) {
    new Azure().removeUser({ subscription: this.subscription_id, remove_user: user_id }, (result) => {
      cb(result.data);
    });
  }
}

export default Subscription;
